module.exports = __webpack_public_path__ + "static/media/cr.2bae0f4d.webp";